import { IStringifyOptions } from 'qs';

export const qsOption: IStringifyOptions = {
  addQueryPrefix: true,
  skipNulls: true,
  arrayFormat: 'comma',
  encode: false,
};
